module.exports = __webpack_public_path__ + "img/icon-question-ses.c29b8bac.svg";